import { h } from 'preact'
import Button from './../ui-components/Button'
import Icon from '../assets'

interface Props {
  onRequest: () => void,
  isLoading: boolean,
  requestPending: boolean
}

const PrivateGroupPlaceholder = ({isLoading, onRequest, requestPending}: Props) => (
  <div className='group-private__placeholder'>
    <div className='group-content-container'>
      { !requestPending && 
        <div>
          <Icon customClass={'icon-locked'} icon={'locked'} />
          <h3>This group is private, please request to join to view topics and members</h3> 
          <div className='group-private__call-to-action'>
            <Button
              type='button'
              class='btn--cta'
              loading={isLoading}
              onClick={onRequest}
            >Request to join</Button>
          </div>
        </div>
      }
      { requestPending && 
        <div>
          <Icon customClass={'icon-clockDestination'} icon={'clockDestination'} />
          <h3>Your join request has been sent, please wait.</h3> 
        </div> 
      }
    </div>
  </div>
)

export default PrivateGroupPlaceholder
